const state = {

    Pricing : []
    
  }
  
  const mutations = {
    SetPricing(state, payload){
        state.Pricing = payload
    },
    SetIndividualPricing(state, payload){
        state.Pricing.push(payload)
    },
    SetIndividualPricingInLoop(state, payload){
      payload.forEach(element => {
            state.Pricing.push(element)
      });
    },
    UpdateIndividualPricing(state, payload){

        let index = state['Pricing'].findIndex(x => x["_id"] == payload["_id"])
        state['Pricing'].splice(index,1,payload)
    },
    DeleteIndividualPricing(state, payload){

        let index = state['Pricing'].findIndex(x => x["_id"] == payload["_id"])
        state['Pricing'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetPricing(state){

        return state.Pricing
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  